<template>
  <div>
    <register-title class="form__title">
      {{ getBodyControl($route.params.body_type).title }}
    </register-title>
    <div v-if="form">
      <div class="center-xs" style="color: white">
        <h1 style="font-weight: normal">"{{ form.name }}"</h1>
        <span>
          Наименование управляющего органа
        </span>
      </div>
      <hr class="horizontal-line" />
      <div class="row">
        <div class="col-xs-12">
          <p style="color: white">Участники / Члены</p>
          <br />
        </div>
        <div
          class="col-xs-12"
          v-for="(body, body_index) in form.members"
          :key="`${body_index}-control-body`"
        >
          <div
            class="rep_minimize light"
            style="margin-top: 0px; padding: 15px;"
          >
            <div class="row middle-xs">
              <div class="col-xs-8">
                <h2 style="font-weight: normal" @click="goEdit(body.id)">
                  {{ body_index + 1 }}. {{ body.full_name }}
                </h2>
              </div>
              <div class="col-xs end-xs">
                <strong
                  class="-with-text-right"
                  style="color: #767d8a"
                  @click="
                    deleteControlMember(body.id, body_index, form.members)
                  "
                  >Удалить
                </strong>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="rep_minimize" style="margin-top:0px; padding: 15px;">
            <div class="row middle-xs">
              <div class="col-xs-8">
                <h2 style="font-weight: normal">
                  Пустой список
                </h2>
              </div>
              <div class="col-xs end-xs">
                <router-link
                  tag="strong"
                  class="-with-text-right"
                  :to="{ name: 'legal-member-form' }"
                  style="color: #1a75e9"
                  >Добавить
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <hr class="horizontal-line" />
        <div class="col-xs-12">
          <router-link
            style="width: 100%;"
            tag="button"
            :to="{ name: 'legal-control-list' }"
            class="button form__button"
          >
            Назад
          </router-link>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>
<style scoped>
.progress {
  min-width: 0%;
  border: 2px solid #1a75e9;
  border-radius: 3px;
  margin-bottom: 5px;
}
.form__input input {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: white;
}
.form__input {
  margin-bottom: 10px;
}
.button {
  margin: 0 !important;
  width: auto;
  display: block !important;
  padding: 9px;
}
</style>
<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";
import ControlFormMixin from "../cotnrol_form_mixin";
export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      form: null,
      members: []
    };
  },
  mixins: [regFormMixin, ControlFormMixin],
  watch: {
    user_profile: function(value) {
      this.fetchForm();
    }
  },
  computed: {
    controlBodies() {
      if (this.user_profile) {
        return this.form_control_bodies.map(body => {
          body.need_to_delete = this.form_list.filter(
            item => item.type === body.type
          );
          if (body.need_to_delete.length > 0) {
            body.data = body.need_to_delete[body.need_to_delete.length - 1];
          } else {
            body.data = null;
          }
          return body;
        });
      }
      return [];
    }
  },
  methods: {
    initControlBody(name, type) {
      FhsAxios.post("profile/user-control/with-members", {
        name: name,
        type: type
      }).then(res => {
        if (res.data.status) {
          this.$toasted.success("Добавлен новый орган правления");
          this.fetchForm();
          this.$router.push({
            name: "legal-control-form-detail",
            params: {
              body_type: type,
              control_id: res.data.result.id
            }
          });
          return;
        }
        this.$toasted.success("Произошла ошибка при сохранении");
      });
    },
    deleteControlMember(id, index, list) {
      this.$toasted.show("Загрузка");
      FhsAxios.post(`profile/user-control-member/${id}/delete`).then(res => {
        if (res.data.status) {
          list.splice(index, 1);
          this.$toasted.clear();
          this.$toasted.show("Удалено");
        } else {
          this.$toasted.show("Произошла ошибка при удалении");
        }
      });
    },
    fetchForm() {
      try {
        this.form =
          this.user_profile.userControls.filter(
            body => body.id == this.$route.params.control_id
          )[0] || null;
        // console.log(this.form);
      } catch (e) {
        console.log(e);
        // ERROR HANDLER
      }
    },
    goEdit(id) {
      this.$router.push({
        name: "legal-member-form-detail",
        params: { member_id: id }
      });
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
